import { Column, CreateDateColumn, Entity,UpdateDateColumn, PrimaryGeneratedColumn, VersionColumn } from "typeorm";

@Entity('plant_operation_capacity')
export class PlantOperationCapacity {
   
    @PrimaryGeneratedColumn("increment",{name:'plant_operation_capacity'})
    plantOperationId:number;

    @Column("int",{
        nullable: true,
        name:"plant_id"
        })
       // @Index({unique:false})
       plantId:number;

      
       @Column("int",{
        nullable: true,
        name:"operation_id"
        })
       // @Index({unique:false})
       operationId:number;

       @Column("varchar",{
        nullable:false,
       name:"min_count"
        })
     mincount:number;

     @Column("varchar",{
        nullable:false,
       name:"max_count"
        })
     maxcount:number;

     @Column("boolean",{
        nullable:false,
        default:true,
        name:"is_active"
        })
      isActive:boolean;

      @CreateDateColumn({
        name: "created_at",
        type:"datetime"
      })
      createdAt: Date;

      @Column("varchar", {
        nullable: false,
        name: "created_user",
        default: "ADMIN",
        length:50
    })
    createdUser: string | null;
    
    @UpdateDateColumn({
        name: "updated_at",
        type:'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length:50
    })
    updatedUser: string | null;

    @VersionColumn({
        default:1,
        name: "version_flag"
    })
    versionFlag: number;
}
